import { Button, type SxProps, type Theme } from '@mui/material';
import { useCallback } from 'react';

interface IRow {
  id: number;
  active: boolean;
}

export interface IArchiveButtonProps {
  sx?: SxProps<Theme>;
  row: IRow;
  onClick: (params: IRow) => void;
}

const ArchiveButton = ({ sx, row, onClick }: IArchiveButtonProps) => {
  const onActionClick = useCallback(() => {
    onClick({ id: row.id, active: !row.active });
  }, [onClick, row]);

  return (
    <Button
      variant='outlined'
      color='primary'
      sx={{
        minHeight: '29px',
        padding: 0,
        paddingX: '8px',
        marginLeft: '8px',
        borderRadius: '32px',
        textWrap: 'nowrap',
        ...sx,
      }}
      onClick={onActionClick}
    >
      {row.active ? 'Archive' : 'Unarchive'}
    </Button>
  );
};

export default ArchiveButton;
